import Vue from 'vue'
import { Watch, Component } from 'vue-property-decorator'
import { AssetsModule } from '@/store/modules/asset'
import { AssetFile, SingleAssetUsage } from '@/store/modules/asset'
import { AssetUsage } from '@/utils/assetUsage'
import { ToolbarDeactivations, ToolbarModule } from '@/store/modules/toolbar'
import { ImageClipper } from '@/utils/imageClipper'
import { TitleType } from '@/store/modules/heartBook'

@Component
export default class SingleAssetUpload extends Vue {
    protected unsubscribeDeselect?: () => void 
    protected asset?: AssetFile

    data() {
        return {
            asset: undefined
        }
    }

    onCancel() {
        if (this.cancel()) {
            this.$emit('cancel')
        }
    }

    onConfirm() {
        if (this.confirmable && this.confirm()) {
            this.$emit('confirm')
        }
    }
    
    cancel(): boolean {
        ToolbarModule.SetDeactivated(ToolbarDeactivations.ZoomAndRotation | ToolbarDeactivations.Deletion)
        ToolbarModule.SetToolbarError(false)
        let asset = AssetUsage.getCommitedAsset()
        if (asset) {
            AssetUsage.prepareUsage(asset)
            AssetsModule.Select(asset)
        } else {
            AssetsModule.Select()
        }
        return true
    }

    confirm(): boolean {
        ToolbarModule.SetDeactivated(ToolbarDeactivations.ZoomAndRotation | ToolbarDeactivations.Deletion)
        if (this.asset !== undefined && this.asset.assetId !== undefined && !ToolbarModule.error) {
            let imageClipper: ImageClipper | undefined
            let usage = AssetUsage.commitUsage(this.asset, true)
            if (usage) {
                imageClipper = ImageClipper.getImageClipper(false)
                imageClipper.initializeUsage(usage, this.asset.rect)
            }
            return this.doConfirm(this.asset, imageClipper, usage)
        } else {
            if (!ToolbarModule.error) {
                return this.doConfirm()
            }
            return false
        }
    }

    goToMenu() {
        if(this.confirmable) {
            this.onConfirm()
        }else {
            this.onCancel()
        }
    }

    doConfirm(asset?: AssetFile, imageClipper?: ImageClipper, usage?: SingleAssetUsage): boolean {
        return false
    }

    get confirmable(): boolean {
        return this.asset !== undefined && !ToolbarModule.error 
    }

    onClick(asset: AssetFile) {
        let selectedAsset = AssetsModule.selected
        if (selectedAsset) {
            AssetUsage.captureUsage(selectedAsset)
        }
        if (!asset.selected) {
            AssetUsage.prepareUsage(asset)
            AssetsModule.Select(asset)
        }
        this.asset = asset
        ToolbarModule.SetDeactivated(ToolbarDeactivations.None)
    }

    get validAssets() {
        return AssetsModule.validAssets
    }

    @Watch('validAssets')
    validAssetsChanged(newValidAssets: AssetFile[]) {
        let selectedAsset = AssetsModule.selected
        if (!selectedAsset && newValidAssets.length > 0) {
            let asset = newValidAssets[0]
            AssetUsage.prepareUsage(asset)
            AssetsModule.Select(asset)
            this.asset = asset
            ToolbarModule.SetDeactivated(ToolbarDeactivations.None)
        }
    }

    mounted() {
        let selectedAsset = AssetsModule.selected
        if (selectedAsset) {
            AssetsModule.Select()
        }

        this.unsubscribeDeselect = this.$store.subscribeAction((a, s) => {
            if (a.type === 'Deselect') {
                let selectedAsset = AssetsModule.selected
                if (selectedAsset) {
                    AssetUsage.captureUsage(selectedAsset)
                    AssetsModule.Select()
                    this.asset = undefined
                    ToolbarModule.SetDeactivated(ToolbarDeactivations.ZoomAndRotation | ToolbarDeactivations.Deletion)
                }
            }
        })
        let asset = AssetUsage.getCommitedAsset()
        if (asset) {
            AssetUsage.prepareUsage(asset)
            AssetsModule.Select(asset)
            this.asset = asset
            ToolbarModule.SetDeactivated(ToolbarDeactivations.None)
        } else {
            ToolbarModule.SetDeactivated(ToolbarDeactivations.ZoomAndRotation | ToolbarDeactivations.Deletion)
        }
    }

    destroyed() {
        if (this.unsubscribeDeselect) {
            this.unsubscribeDeselect()
        }
    }

    activate() {
        if (this.asset) {
            ToolbarModule.SetDeactivated(ToolbarDeactivations.None)
        }
    }
}